import { render, staticRenderFns } from "./SpaceFortnoxSettings.vue?vue&type=template&id=4fe5f190"
import script from "./SpaceFortnoxSettings.vue?vue&type=script&lang=js"
export * from "./SpaceFortnoxSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports